<template>
  <div class="my_address">
    <van-overlay :show="loading">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
    <div v-if="list.length > 0">
      <div class="ad1" v-for="(item,index) in list" :key="index">
        <div class="ad1-1">
          <div class="ad1-1-le">
            <img class="img" src="@/assets/image/icon_add@3x.png" alt />
          </div>
          <div class="ad1-1-ri">
            <div>{{item.provinceName}}{{item.cityName}}{{item.areaName}}{{item.address}}</div>
            <div>{{item.userName}} &nbsp;&nbsp; {{item.userMobile}}</div>
          </div>
        </div>
        <div class="ad1-2">
          <div>
            <van-checkbox
              @click="select(item, index)"
              class="div1" 
              icon-size="16px"
              checked-color="#F8D541"
            >选择此地址</van-checkbox>
          </div>
          <div class="div2">
            <span @click.once="onEdit(item, index)">编辑</span>
          </div>
          <!-- <div class="div3" @click="onDelete(item)">删除</div> -->
        </div>
      </div>
      <div class="navbar-fixed">
        <div class="foot-btn" @click.once="onAdd">新增收货地址</div>
      </div>
    </div>
    <div class="ad1" v-else>
      <div class="ad2">
        <empt title="一个地址也没有" info="“快去添加收货地址”" :url="$theme.general_icon_empty" ></empt> 
        <div @click.once="onAdd" class="no2"><van-button class="but">添加收货地址</van-button></div>
      </div>
    </div>
    
  </div>
</template>
<script>
import http from "@/utils/axios";
import empt from '@/views/shareDiscovery/components/emptyItem'
export default {
  data() {
    return {
      show:false,
      loading: false,
      chosenAddressId: 1,
      addressId:0,
      list: [],
      imge1: require('@/assets/image/empty_icon.png'),
      onSubmitLoading: false
    };
  },
  methods: {
    onAdd() {
      this.$router.push({ name: "personnelADDAddress", query: { branchId: this.$route.query.branchId, afterId: this.$route.query.afterId } });
    },
    onEdit(item, index) {
      this.$router.push({ name: "personnelADDAddress" , query: { branchId: item.branchId, id: item.id } });
    },
    select(item, index) {
      let row = JSON.parse(JSON.stringify(item))
      row.afterId = this.$route.query.afterId
      this.$store.dispatch('setBeeRetAddressData', row)
      this.$router.push({ name: "personnelAddressSure"});
    },
    onDelete(item) {
      this.$dialog
        .confirm({
          title: "",
          message: "确定删除吗?"
        })
        .then(() => {
          this.doDelete(item);
        })
        .catch(() => {
          // on cancel
        });
    },
    doDelete(item) {
      http({
        url: "base/user/address/delete/" + item.id,
        method: "get"
      }).then(rps => {
        if (rps.code === 200) {
          this.$notify({ type: "success", message: "删除成功！" });
          this.getData();
        }
      });
    },
    getData(flag) {
      this.loading = true;
      http({
        url: "order/app/branch/address/page",
        method: "post",
        parmes: {
          branchId: this.$route.query.branchId,
          pageIndex: 1,
          pageSize: 100
        }
      }).then(rps => {
        this.loading = false;
        this.$loading.hide();
        if (rps.code === 200) {
          this.list = rps.data;
          flag && this.$router.back();
        }
      });
    },
  },
  created() {
    this.getData();
  },
  components:{empt},
};
</script>
<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.my_address {
  background-color: #f7f7f7;
  padding: 30px;
  padding-bottom: 120px;
}
.ad1 {
  font-size: 28px;
  color: #333333;
  border-radius: 20px;
  margin-bottom: 28px;
  background-color: #fff;
  .ad1-1 {
    padding-left: 40px;
    padding-right: 50px;
    padding-top: 59px;
    margin-bottom: 56px;
    display: flex;
    .ad1-1-le {
      width: 80px;
      height: 70px;
      text-align: center;
      padding-top: 10px;
    }
    .ad1-1-ri {
      margin-left: 20px;
      width: 80%;
    }
  }
  .ad1-2 {
    padding-left: 40px;
    padding-right: 50px;
    margin-top: 56px;
    border-top: 2px solid #f2f2f2;
    font-size: 24px;
    display: flex;
    height: 84px;
    line-height: 84px;
    justify-content: left;
    clear: both;
    .div1 {
      height: 84px;
      line-height: 84px;
    }
    .div2 {
      text-align: right;
      width: 420px;
    }
  }
  
}
.foot-btn {
  font-size: 26px;
  width: 600px;
  height: 88px;
  line-height: 88px;
  background-color: var(--epButtonColor);
  color: var(--epTextColor);
  border-radius: 44px;
  text-align: center;
}
.navbar-fixed {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  justify-content: center;
  z-index: 3;
  border-top: 0.01rem solid #fafafa;
  padding-top: 16px;
  padding-bottom: 16px;
}
.ad2{
  padding-top: 180px;
  padding-left: 150px;
  padding-right: 150px;
  padding-bottom: 200px;
}
.no2{
  text-align: center;
  margin: 20px 30px 68px 30px;
}
.but{
  width:240px;
  height:64px;
  background: var(--epButtonColor);
  color: var(--epTextColor);
  border-radius:32px;
  line-height: 64px;
}
</style>